// src/utils/updatePaths.js

import serverConfig from "../config";

const UpdatePaths = (htmlContent, path_img, path_file) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  const images = doc.querySelectorAll("img");

  /*
  images && images.length > 0 && images.forEach((img) => {
    const src = img.getAttribute("src");
    const newSrc = `${serverConfig.serverUrl}/${path_img}${src.replace(/^\.\.\//, "")}`;
    img.setAttribute("src", newSrc);
  });
  */
  if (images && images.length > 0) {
    images.forEach((img) => {
      const src = img.getAttribute("src");
      const newSrc = `${serverConfig.serverUrl}/${path_img}${src.replace(
        /^\.\.\//,
        ""
      )}`;
      img.setAttribute("src", newSrc);
    });
  }

  const links = doc.querySelectorAll("a");
  if (links && links.length > 0) {
    links.forEach((link) => {
      const href = link.getAttribute("href");
      
      if (href && (href.endsWith(".pdf") || href.endsWith(".doc"))) {
        const newHref = `${serverConfig.serverUrl}/${path_file}${href.replace(
          /^\.\.\//,
          ""
        )}`;
        link.setAttribute("href", newHref);
      } else if (href && href.startsWith("home")) {
        // Handle relative links
        const newHref = `/${href}`;
        link.setAttribute("href", newHref);
      }
    });
  }

  return doc.body.innerHTML;
};

export default UpdatePaths;
